import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function GreetingText({
  interval = 2200,
  greetings = [
    { text: "hi", lang: "en" },
    { text: "namaste", lang: "hi" },
    { text: "hola", lang: "es" },
  ],
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % greetings.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, greetings.length]);

  const current = greetings[index];

  return (
    <div className="flex w-full items-end overflow-hidden">
      
      {/* SAY */}
      <span className="shrink-0 font-pixeloperator text-[clamp(3.5rem,9vw,125px)] leading-none">
        Say,
      </span>

      {/* ROTATING TEXT */}
      <span className="relative flex-1 h-[clamp(3.5rem,9vw,125px)] min-w-0 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span
            key={index}
            lang={current.lang}
            initial={{ y: "100%", opacity: 0, rotateX: -45 }}
            animate={{ y: "0%", opacity: 1, rotateX: 0 }}
            exit={{ y: "-100%", opacity: 0, rotateX: 45 }}
            transition={{
              duration: 0.65,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="absolute bottom-0 left-0 ml-1 whitespace-nowrap font-pixeloperator text-[clamp(3.5rem,9vw,125px)] leading-none"
            style={{ transformOrigin: "center bottom" }}
          >
            {current.text}
          </motion.span>
        </AnimatePresence>
      </span>
    </div>
  );
}